import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Tooltip from 'shopper/components/Tooltip';

const StatsItem = ({ children, className, tooltipText = null, ...rest }) => (
  <div
    className={twMerge(
      'flex min-w-max items-center justify-center border-r border-solid border-neutral-high-200 px-4 dark:border-neutral-low-300 lg:w-1/4 lg:min-w-unset',
      className
    )}
    {...rest}
  >
    {tooltipText ? (
      <Tooltip.Root>
        <Tooltip.Trigger>{children}</Tooltip.Trigger>
        <Tooltip.Box align="left" className="md:w-[260px] lg:w-[380px]">
          {tooltipText}
        </Tooltip.Box>
      </Tooltip.Root>
    ) : (
      children
    )}
  </div>
);

StatsItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  tooltipText: PropTypes.string,
};

export default StatsItem;
